import * as PIXI from "pixi.js";
import Game from "../../../Game";
import Layers from "../../../layers/Layers";
import { BaseSliderProps } from "../../../types/Interface";
import { Slider } from "@pixi/ui";


export default class CustomSliderRenderer extends PIXI.Container {
  private Game = Game.getInstance();
  private Layers = Layers.getInstance();
  private isVertical: boolean = false;
  private options: BaseSliderProps;
  private head = this.addChild(new PIXI.Text());
  private subHead = this.addChild(new PIXI.Text());
  private bg = this.addChild(new PIXI.Graphics());
  private button = this.addChild(new PIXI.Graphics());
  private barTransparent = this.addChild(new PIXI.Graphics());
  private bar = this.addChild(new PIXI.Graphics());
  public Slider: Slider;

  constructor(props: BaseSliderProps) {
    super();
    
    this.options = props;
    this.setCoord();
    this.getIsVertical();
    this.generateHead(props.head);
    props.subHead && this.generateSubHead(props.subHead);
    this.generateBg();
    this.generateSliderButton();
    this.generateBar(this.bar);
    this.generateBar(this.barTransparent, true);
    this.generateSlider();
    this.deactiveEventMode();
    this.addToLayer();
  }  

  private addToLayer = () => this.Layers.UI.addChild(this);
  private setCoord = () => this.position.copyFrom(this.options);
  public getBarGraphs = () => [this.bar, this.barTransparent];
  private deactiveEventMode = () => [this.bg, this.head, this.subHead].forEach(e => e.eventMode = "none");
  private getIsVertical() {
    const dim = this.Game.getDim();
    this.isVertical = dim.WIDTH < dim.HEIGHT;
  }
  private generateHead(label: string) {
    this.head.text = label;
    this.head.style.fontWeight = "700";
    this.head.style.fontSize = this.isVertical ? 30 : 25;
    this.head.anchor.set(.5);
    this.head.x = this.isVertical ? 115 : 140;
    this.head.y = -90;
  }
  private generateSubHead(label: string) {
    this.subHead.text = label;
    this.subHead.style.fontWeight = "500";
    this.subHead.style.fontSize = 15;
    this.subHead.anchor.set(.5);
    this.subHead.x = this.isVertical ? 115 : 140;
    this.subHead.y = -70;
  }
  private generateBar(bar: PIXI.Graphics, isTransparent: boolean = false) {
    this.isVertical ? bar.roundRect(0, -10, 230, 20, 8) : this.bar.rect(0, -5, 280, 10);
    bar.fill({ color: this.options.sliderStyle.barColor, alpha: isTransparent ? 0 : .5 });
  }
  private generateSliderButton() {
    this.isVertical ? this.button.circle(0, -10, 30) : this.button.rect(-15, -30, 30, 50);
    this.button.fill(this.options.sliderStyle.buttonColor);
    this.button.cursor = "none";
  }
  private generateBg() {
    this.isVertical
      ? this.bg.roundRect(-25, -60, 280, 120, 30) 
      : this.bg.roundRect(-25, -60, 330, 120, 25);
    this.bg
      .fill({ color: this.options.sliderStyle.bgColor, alpha: .2 })
      .stroke({ color: 0x000000, width: 3 });
  }
  private generateSlider() {
    this.Slider = new Slider({
      bg: this.bar,
      fill: this.barTransparent,
      slider: this.button,
      min: 0,
      max: 200,
      value: 100,
    });
    this.addChild(this.Slider);
  }
}